export default __webpack_public_path__ + "img/sidebar_explore.ca3ddf0a.svg";